<template>
  <div>
    <img src="@/assets/tarjeta_ofertas_mes_mmt_febrero_2026.jpg" style="width: 100%" />
    <p class="tituloTarjeta">¡ESTAMOS DE ANIVERSARIO!</p>
    <p>
      Contrata AHORA y llévate un <b>10% de DESCUENTO</b> en Seguros de HOGAR, COCHE, NEGOCIOS, ACCIDENTES Y MASCOTAS.
    </p> 
    <p>
      ¡Toda tu protección en MMT!
    </p> 

     <p class="nota-campana">*Campaña válida para nuevas contrataciones</p>
    
        <p class="container-flex">
      <a :href="'tel:' + telefonoOwner" >
        <button class="pure-button botonLlamar" title="Pulsa el botón para llamar a tu oficina MMT">
          Llamar 
        </button>
      </a>


      <a href="https://www.mmtseguros.com/oficinas" target="_blank" class="link" v-if="visibleBotonMasInfo">
        <button class="pure-button botonLlamar">Más información</button>
      </a>
    </p>

  </div>
</template>

<script>
/* eslint-disable no-console */
export default {
  data() {
    return {
      telefonoOwner:
        this.$store.state.portfolio.cliente.telefonoOwnerPropioCliente,
    };
  },

  computed: {
    visibleBotonMasInfo() {
      return (
         !this.$store.state.portfolio.cliente.ownerPropioClienteCanalTelefonico
      );
    }
  }

};


</script>

<style lang="scss" scoped>
.container-flex {
  margin-top: 2.5rem;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  row-gap: 0.5rem;
  justify-content: space-around;
}

.botonLlamar {
  background-color: $colorMMT;
  color: white;
  font-weight: bold;
  width: 9rem;
  border: 0.15rem solid;
  border-radius: 0.5rem;
  text-align: center;
}

.nota-campana {
  font-size: 0.85rem;  
  font-style: italic;  
  color: #666;         
  margin-top: 10px;
}
</style>